/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Box, HStack, Tag } from '@chakra-ui/react';
import { type FunctionComponent, useMemo, useState } from 'react';
import { IoChevronDown, IoChevronForward } from 'react-icons/io5';
import { type Column } from 'react-table';
import { type Frame } from '../../interface/Crash';
import { TableContainer } from '../table/TableContainer';
import { Code } from '../Code';

interface Props {
    frame: Frame;
    highlightColor?: string;
}

export const BindingsItem: FunctionComponent<Props> = (props: Props) => {
    const { frame, highlightColor } = props;
    const [showDetails, setShowDetails] = useState(false);

    const bindingsItems = Object.entries(frame.bindings);
    const tableData = useMemo(() => bindingsItems, [bindingsItems]);
    const columns = useMemo(
        () => [
            {
                Header: 'name',
                accessor: (row) => row[0],
                disableSortBy: true,
                minWidth: 1,
                width: 2,
                maxWidth: 2,
            },
            {
                Header: 'value',
                accessor: (row) => JSON.stringify(row[1], null, 2),
                Cell: ({ cell: { value } }: { cell: { value: string } }) => {
                    const splitLength = 5000;
                    const displayValue = value.length > splitLength ? value.slice(0, splitLength) + ' [...]' : value;
                    return (
                        <Code wrapWhiteSpace={true} textToCopy={value}>
                            {displayValue}
                        </Code>
                    );
                },
                disableSortBy: true,
            },
        ],
        [bindingsItems],
        // any is in real Array<Column<Array<string>>>, but TabelContainer can't work with it
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ) as Array<Column<any>>;

    return (
        <>
            <HStack spacing="1">
                <Box
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                        setShowDetails(!showDetails);
                    }}
                >
                    {showDetails ? <IoChevronDown size="25" /> : <IoChevronForward size="25" />}
                </Box>
                <Box overflow="hidden">
                    <HStack>
                        <Tag variant="solid" colorScheme="blue">
                            {frame.source}
                        </Tag>
                        <Tag variant="outline" colorScheme="blue">
                            {frame.version}
                        </Tag>
                        <Tag variant="subtle" colorScheme="teal">
                            {frame.linedefined}
                        </Tag>
                        <Tag variant="solid" colorScheme="teal">
                            {frame.name}
                        </Tag>
                        <Tag variant="solid" colorScheme="red">
                            {frame.currentline}
                        </Tag>
                    </HStack>
                    <Code mt="2px" p={2} borderRadius="md" w="full" colorScheme={highlightColor ?? 'gray'}>
                        {frame.currentlineCode}
                    </Code>
                </Box>
            </HStack>
            {showDetails && tableData && columns && (
                <TableContainer
                    columns={columns}
                    data={tableData}
                    search={{
                        placeholder: 'Search in Bindings',
                    }}
                    searchBarStyles={{ paddingLeft: '20px' }}
                />
            )}
        </>
    );
};
